import moment from 'moment';
import { useForm } from '@ox/visits-ui/context/FormContext';

export function SaveIndicator() {
  const { saveStatus, lastSavedAt } = useForm();

  if (saveStatus === 'idle') {
    return <div style="position: fixed;" />;
  }

  return (
    <div className={`save-indicator save-indicator--${saveStatus}`}>
      {saveStatus === 'saving' && (
        <>
          <span className="spinner" />
          <span>Saving...</span>
        </>
      )}
      {saveStatus === 'saved' && lastSavedAt && (
        <>
          <span className="checkmark">√</span>
          <span>Saved {moment(lastSavedAt).fromNow()}</span>
        </>
      )}
      {saveStatus === 'error' && (
        <>
          <span className="checkmark">∆</span>
          <span>Save failed</span>
        </>
      )}
    </div>
  );
}